import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "unhide", "toggleable" ]

    togglePassword(){
        if (this.unhideTarget.type === "password") {
            this.toggleableTarget.classList.remove('fa-eye');
            this.toggleableTarget.classList.add('fa-eye-slash');
            this.unhideTarget.type = "text";
        } else {
            this.toggleableTarget.classList.remove('fa-eye-slash');
            this.toggleableTarget.classList.add('fa-eye');
            this.unhideTarget.type = "password";
        }
    }
}